import type { DocumentTypeConfig } from "../types";
import {
  NOTIFICATION_SERVICE_ROWS,
  NOTIFICATION_NONE_SERVICE_ROW,
} from "../constants";

const serviceMappings = NOTIFICATION_SERVICE_ROWS.map((s) => ({
  cell: `D${s.row}`,
  field: `service_row_${s.row}`,
  valueType: "string" as const,
  required: false,
}));

const noneServiceMapping = {
  cell: `D${NOTIFICATION_NONE_SERVICE_ROW}`,
  field: "service_row_none",
  valueType: "string" as const,
  required: false,
};

export const notificationConfig: DocumentTypeConfig = {
  documentType: "notification",
  supportedFormats: ["xlsx", "pdf"],
  xlsx: {
    version: {
      cell: "O17",
      sheetName: "Introducere",
      sheetIndex: 0,
      expectedVersions: ["V2.2", "V2.1", "V1.0"],
    },
    sheets: [
      {
        sheetName: "Date entitate",
        sheetIndex: 2,
        mappings: [
          {
            cell: "D12",
            field: "denumire_entitate",
            valueType: "string",
            required: true,
          },
          { cell: "D13", field: "cui", valueType: "string", required: true },
          { cell: "D14", field: "cif", valueType: "string", required: true },
          { cell: "D17", field: "judet", valueType: "string", required: false },
          {
            cell: "D18",
            field: "localitate",
            valueType: "string",
            required: false,
          },
          {
            cell: "D19",
            field: "sector",
            valueType: "string",
            required: false,
          },
          {
            cell: "D20",
            field: "strada",
            valueType: "string",
            required: false,
          },
          { cell: "D21", field: "numar", valueType: "string", required: false },
          { cell: "D22", field: "bloc", valueType: "string", required: false },
          {
            cell: "D26",
            field: "cod_postal",
            valueType: "string",
            required: false,
          },
          { cell: "D27", field: "email", valueType: "string", required: false },
          {
            cell: "D28",
            field: "website",
            valueType: "string",
            required: false,
          },
          {
            cell: "D29",
            field: "telefon_fix",
            valueType: "string",
            required: false,
          },
          {
            cell: "D30",
            field: "telefon_mobil",
            valueType: "string",
            required: false,
          },
          {
            cell: "D32",
            field: "caen_principal",
            valueType: "string",
            required: false,
          },
          {
            cell: "D33",
            field: "caen_secundare",
            valueType: "string",
            required: false,
          },
          {
            cell: "C37",
            field: "securitate_desemnata",
            valueType: "string",
            required: false,
          },
          {
            cell: "D38",
            field: "securitate_nume",
            valueType: "string",
            required: false,
          },
          {
            cell: "D39",
            field: "securitate_prenume",
            valueType: "string",
            required: false,
          },
          {
            cell: "D40",
            field: "securitate_functia",
            valueType: "string",
            required: false,
          },
          {
            cell: "D41",
            field: "securitate_email",
            valueType: "string",
            required: false,
          },
          {
            cell: "D42",
            field: "securitate_telefon",
            valueType: "string",
            required: false,
          },
          {
            cell: "D44",
            field: "persoana_contact",
            valueType: "string",
            required: false,
          },
          {
            cell: "C45",
            field: "contact_aceeasi_persoana",
            valueType: "string",
            required: false,
          },
          {
            cell: "D46",
            field: "contact_nume",
            valueType: "string",
            required: false,
          },
          {
            cell: "D47",
            field: "contact_prenume",
            valueType: "string",
            required: false,
          },
          {
            cell: "D48",
            field: "contact_functia",
            valueType: "string",
            required: false,
          },
          {
            cell: "D50",
            field: "contact_telefon_mobil",
            valueType: "string",
            required: false,
          },
          {
            cell: "D51",
            field: "contact_telefon_fix",
            valueType: "string",
            required: false,
          },
          {
            cell: "D52",
            field: "contact_email",
            valueType: "string",
            required: false,
          },
          {
            cell: "D54",
            field: "ip_publice",
            valueType: "string",
            required: false,
          },
          {
            cell: "D81",
            field: "rep_legal_nume",
            valueType: "string",
            required: false,
          },
          {
            cell: "D82",
            field: "rep_legal_prenume",
            valueType: "string",
            required: false,
          },
          {
            cell: "D83",
            field: "rep_legal_functia",
            valueType: "string",
            required: false,
          },
        ],
      },
      {
        sheetName: "Evaluare entitate",
        sheetIndex: 3,
        mappings: [
          {
            cell: "D17",
            field: "nr_salariati",
            valueType: "number",
            required: false,
          },
          {
            cell: "D18",
            field: "cifra_afaceri",
            valueType: "number",
            required: false,
          },
          {
            cell: "D19",
            field: "active_totale",
            valueType: "number",
            required: false,
          },
          {
            cell: "D21",
            field: "dimensiune",
            valueType: "string",
            required: false,
          },
          {
            cell: "D150",
            field: "stabilita_romania",
            valueType: "string",
            required: false,
          },
          {
            cell: "D151",
            field: "sediu_principal_romania",
            valueType: "string",
            required: false,
          },
          {
            cell: "D159",
            field: "furnizare_servicii_romania",
            valueType: "string",
            required: false,
          },
          {
            cell: "D160",
            field: "furnizare_servicii_ue",
            valueType: "string",
            required: false,
          },
          {
            cell: "D161",
            field: "furnizare_servicii_ue_state_membre",
            valueType: "string",
            required: false,
          },
          {
            cell: "D169",
            field: "art_9a",
            valueType: "string",
            required: false,
          },
          {
            cell: "D170",
            field: "art_9b",
            valueType: "string",
            required: false,
          },
          {
            cell: "D171",
            field: "art_9c",
            valueType: "string",
            required: false,
          },
          {
            cell: "D172",
            field: "art_9d",
            valueType: "string",
            required: false,
          },
          {
            cell: "D176",
            field: "evaluare_preliminara",
            valueType: "string",
            required: false,
          },
          ...serviceMappings,
          noneServiceMapping,
        ],
      },
    ],
  },
};
